/**
 * @author Ariel
 * @date 2020-09-23
 * @desc 活动环节查看
 */
import React from "react";
import {connect} from 'dva';
import {Descriptions} from 'antd';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import moment from "moment";

let {WizContainer, modelUtils, ossFileUtils} = framework_tool
let {WizCard, WizRow, WizCol, WizButton} = component_tool
let {Session, $$} = utils_tool

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const _getValue = (type, key) => {
  const values = {
    partType: {
      0: '课程',
      1: '考试',
      2: '投票',
      3: '系列化课程',
      4: '图片',
      5: '链接',
      6: '视频',
    },
    active: {
      0: '关闭',
      1: '打开',
    },
  }
  return values[type][key]
}

class ActivityPartLook extends WizContainer {
  componentName = 'activityPartLook'

  constructor(props) {
    super(props)
    const {history} = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/interact/activity/activityDetailToPart/activityPartLook') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('detailInfo', detailInfo)
      } else {
        detailInfo = Session.get('detailInfo') || {}
      }
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
    if (this.detailInfo && this.detailInfo.id) {
      this.doAction({
        path: 'activityPart/look',
        payload: {
          key: 'activityPartInfo',
          apiParams: {id: this.detailInfo.id}
        }
      })
    }
  }

  getImgList = (fileIds,type) => {
    let r = []
    let fileList = fileIds && fileIds.split(',')
    if (fileList && fileList.length && fileList.length > 0) {
      fileList.forEach(fileId => {
        let img = type && type === 6 ?
          <video height={160} width={240} controls={true} loop={true}>
            <source src={getOssFilePath(fileId)} type="video/mp4"/>
          </video> : <img height={80} width={80} src={getOssFilePath(fileId)}/>
        r.push(
          <WizCol style={{padding: 8}}> {img} </WizCol>
        )
      });
    }
    return <WizRow style={{display: 'flex', marginRight: 0}}>{r}</WizRow>
  }

  _getItem = (items) => {
    let {type, fileIds, coverImg, linkUrl, linkRemark} = items
    let typeName = _getValue('partType', type)
    if (type <= 3) {
      let typeLink = '/interact/activity/activityDetailToPart/activityPartLook/toProgram';
      switch (type) {
        case 1 :
          typeLink = '/interact/activity/activityDetailToPart/activityPartLook/toExam';
          break;
        //case 2;
        case 3 :
          typeLink = '/interact/activity/activityDetailToPart/activityPartLook/toSeries';
          break;
      }
      return (
        <Descriptions.Item label={'关联' + typeName}>
          <WizButton
            type='link'
            tooltip={items.entityName}
            onClick={() => {
              this.jumpPage && this.jumpPage(
                'push',
                typeLink,
                {id: items.entityId}
              )
            }}>
            {items.entityName}
          </WizButton>
        </Descriptions.Item>
      )
    }
    if (type === 4) {
      return (
        <Descriptions.Item label='图片'>
          {this.getImgList(fileIds)}
        </Descriptions.Item>
      )
    }
    if (type === 5) {
      let item = <Descriptions.Item label='链接图片'>{this.getImgList(coverImg)}</Descriptions.Item>
      let item2 = <Descriptions.Item label='链接地址'>{linkUrl}</Descriptions.Item>
      let item3 = <Descriptions.Item label='链接描述'>{linkRemark}</Descriptions.Item>
      let linkArr = [item, item2, item3]
      return linkArr
    }
    if (type === 6) {
      let item = <Descriptions.Item label='视频封面图片'>{this.getImgList(coverImg)}</Descriptions.Item>
      let item2 = <Descriptions.Item label='视频'>{this.getImgList(fileIds,type)}</Descriptions.Item>
      let linkArr = [item, item2]
      return linkArr
    }
  }

  _render() {
    let {activityPartInfo} = this.props
    if (activityPartInfo && activityPartInfo.success) {
      this.detailInfo = activityPartInfo.data
    }
    const items = this.detailInfo

    return (
      <React.Fragment>
        <WizCard>
          <Descriptions column={1} style={{paddingLeft: 25}} bordered={true}>
            <Descriptions.Item label='环节名称'>{items.title}</Descriptions.Item>
            <Descriptions.Item
              label='环节时间'>{formatterDate(items.startTime)} ~ {formatterDate(items.endTime)}</Descriptions.Item>
            <Descriptions.Item label='环节类型'>{_getValue('partType', items.type)}</Descriptions.Item>
            {this._getItem(items)}
            {/*<Descriptions.Item label='积分'>{items.score}</Descriptions.Item>*/}
            <Descriptions.Item label='状态'>{_getValue('active', items.active)}</Descriptions.Item>
            <Descriptions.Item label='简介'>{items.remark}</Descriptions.Item>
          </Descriptions>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {activityPart} = state;
  const activityPartInfo = modelUtils.getModelEntity(activityPart, 'activityPartInfo');
  const load = modelUtils.getLoadingState(state, 'activityPart')
  return {
    activityPartInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ActivityPartLook)
